<template>
  <div>
    <div class="tc mb-4">
      <h3>自开彩下注时间设定</h3>
    </div>
    <lidaTable
      ref="lidaTable"
      :propscolumns="columns"
      :data="filterData"
      :propsPageSize="50"
    >
      <template v-slot:headerSelect>
        站别类型：
        <Select
          v-model="site"
          style="width: auto"
          class="mr-3"
        >
          <Option
            v-for="item in siteAllList"
            :value="item.id"
            :key="item.id"
          >{{
            item.value
          }}</Option>
        </Select>彩种系列
        <Select
          v-model="gameKind"
          style="width: auto"
        >
          <Option
            v-for="item in gameSeries"
            :value="item.id"
            :key="item.id"
          >{{
            item.value
          }}</Option>
        </Select>
      </template>
    </lidaTable>
    <div
      v-if="getpermission.gameset[5] == 1"
      class="text-center"
    >
      <Button
        type="error"
        size="default"
        @click="confirm"
      >储存</Button>
    </div>
  </div>
</template>
<script>
import BetTimeSelect from './components/BetTimeSelect'
import { mapGetters } from 'vuex'
import siteGroup from 'utils/site-group.js'
import GameGroupMethods from 'utils/game-group-methods.js'
import site from '@/mixins/site'
import common from '@/views/game-lobby/mixins/common.js'

const gameGroupMethods = new GameGroupMethods()
export default {
  name: 'self-lottery-bet-time',
  mixins: [site, common],
  data () {
    return {
      columns: {
        siteId: {
          title: '站别类型',
          align: 'center',
          key: 'siteId',
          className: 'bet-time-bg',
          sortable: 'custom',
          render: (h, params) => {
            if (!siteGroup.items[params.row.siteId]) return
            let word = siteGroup.items[params.row.siteId]
            return h('span', word)
          }
        },
        gamekind: {
          title: '彩种系列',
          align: 'center',
          key: 'gamekind',
          render: (h, params) => {
            return h('span', params.row.gamekind.text)
          }
        },
        gamename: {
          title: '彩种名称',
          align: 'center',
          key: 'gamename',
          sortable: 'custom'
        },
        bettime: {
          title: '下注时间设定',
          align: 'center',
          key: 'bettime',
          render: (h, params) => {
            return h(BetTimeSelect, {
              props: {
                bettime: params.row.bettime,
                gameid: params.row.gameid,
                row: params.row
              },
              on: {
                'update:bettime.ut': (val, gameid) => {
                  this.filterData.forEach(it => {
                    if (it.gameid == gameid) {
                      it.bettime.ut = val
                      it.bettime.time = val == 1 ? 75 : 1
                    }
                  })
                },
                'update:bettime.time': (val, gameid) => {
                  this.filterData.forEach(it => {
                    if (it.gameid == gameid) {
                      it.bettime.time = val
                    }
                  })
                },
                getNewData: (obj) => {
                  if (this.postData.length < 1 || this.postData.every(it => it.gameid != obj.gameid)) {
                    this.postData.push({
                      ...obj,
                      betPeriodClTime: params.row.betPeriodClTime,
                      betPeriodOpTime: params.row.betPeriodOpTime
                    })
                    return
                  }
                  this.postData = this.postData.map((it, index) => {
                    if (!obj.gameid) return
                    if (it.gameid == obj.gameid) {
                      it.ut = obj.ut
                      it.time = obj.time
                    }
                    return it
                  })
                }
              },
            })
          },
        }
      },
      data: [],
      utarr: [1, 2],
      namearr: [
        { val: '12gc5' },
        { val: '12gc9' },
        { val: '12gc' },
      ],
      site: 999,
      gameKind: 0,
      name: '',
      postData: [],
    }
  },
  computed: {
    ...mapGetters(['getAllGame', 'getmember', 'getpermission']),
    filterData () {
      let obj = JSON.parse(JSON.stringify(this.data))
      obj = obj.filter((it, index) => {
        if (this.site != 999 && this.gameKind != 0) {
          return it.siteId == this.site && it.gamekind.val == this.gameKind
        } else if (this.site !== 999) {
          return it.siteId == this.site
        } else if (this.gameKind !== 0) {
          return it.gamekind.val == this.gameKind
        } else {
          return it
        }
      })
      return obj
    },
    siteAllList() {
      return siteGroup.allSelect()
    }
  },
  watch: {
    getAllGame: {
      immediate: true,
      handler () {
        this.getData()
      }
    }
  },
  methods: {
    async getData () {
      if (!this.getAllGame.length) return
      try {
        let res = await this.$axios.gameLobby.gameBetTimelist()
        if ('status' in res && res.status === 0) return
        this.data = res.map(it => {
          if ((it.betSeconds / 60) >= 60) {
            it.bettime = {
              ut: 3,
              time: it.betSeconds / 3600
            }
          }
          if ((it.betSeconds / 60) < 60) {
            if (it.betSeconds % 60 != 0) {
              it.bettime = {
                ut: 1,
                time: it.betSeconds
              }
            } else {
              it.bettime = {
                ut: 2,
                time: it.betSeconds / 60
              }
            }
          }
          let gameobj = this.getAllGame.filter(ait => ait.gameid == it.gameid)[0]
          it.gamekind = { val: gameobj.catenaId, text: gameGroupMethods.catenaGroup(gameobj.catenaId) }
          return it
        }).reverse()
      } catch (error) {
        console.error(error)
      }
    },
    async confirm () {
      try {
        if (this.postData.length < 1) return this.$Message.error('无修改')
        let postData = []
        this.postData.forEach(it => {
          let obj = {
            gameid: it.gameid,
            newbetSeconds: this.getnewbetSeconds(it),
            betPeriodOpTime: it.betPeriodOpTime,
            betPeriodClTime: it.betPeriodClTime,
          }
          postData.push(obj)
        })
        let res = await this.$axios.gameLobby.gameBetTimeUpd({ loid: this.getmember.pid, misve: postData })
        if (res.status != 1) return
        this.$Notice.success({ title: "修改成功" });
        this.getData()
        this.postData = []
        this.$refs.lidaTable.restart(1)
      } catch (error) {
        console.error(error);
      }
    },
    getnewbetSeconds (obj) {
      let newbetSeconds
      switch (obj.ut) {
        case 1:
          newbetSeconds = obj.time
          break;
        case 2:
          newbetSeconds = obj.time * 60
          break;
        case 3:
          newbetSeconds = obj.time * 3600
          break;
      }
      return newbetSeconds
    },
  }
}
</script>
<style lang="scss">
.ivu-table-tbody {
  .bet-time-bg {
    background-color: $header-site-supervision-bg;
  }
}
</style>